import axios from 'axios';

const baseURL = process.env.REACT_APP_BASE_URL;

/**
 * Fetches multiple CMS records in one request.
 * @param {string[]} slugs
 * @returns {Promise<Record<string, object>>}
 */
export const fetchCmsBySlugs = async (slugs) => {
    const response = await axios.get(`${baseURL}/cms/bulk`, {
        params: { slugs: slugs.join(',') },
    });

    return response.data.data || {};
};

/**
 * @param {object|null|undefined} cmsRow
 * @param {string} language
 * @returns {string}
 */
export const getCmsLocalizedText = (cmsRow, language) => {
    if (!cmsRow) {
        return '';
    }

    return cmsRow[language] ?? cmsRow.en ?? '';
};
